var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('a',{staticClass:"mobile-header-login-btn",on:{"click":_vm.loginRedirect}},[_c('img',{attrs:{"src":_vm.$config.images['userAvatar']}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$config.strings['header-mobile-btn'])}})])])}
var staticRenderFns = []

export { render, staticRenderFns }